import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { googleMaps } from '../../HOC/GoogleMapsHOC';
import { auth } from '../../Auth';

export function SchedulingMapWrapper({ loaded, children }) {
  const mapRef = useRef(null);
  const [mapInstance, setMapInstance] = React.useState(null);
  
  // 1. Select only what we need
  const project = useSelector(state => state.project);


  useEffect(
    function () {
      if (!loaded || !mapRef.current || mapInstance) return;

      let location;

      if (project.id && project.site?.geocode_results?.geometry?.location) {
        location = project.site.geocode_results.geometry.location;
      } else if (auth.sunkaizenUser.geocode_results) {
        location = auth.sunkaizenUser.geocode_results.geometry.location;
      } else {
        location = { lat: 39.8333333, lng: 98.585522 * -1 };
      }

      const map = new window.google.maps.Map(mapRef.current, {
        center: location,
        zoom: 4,
        mapId: "schedulingMap",
        zoomControl: true,       // Shows the + / - buttons
        streetViewControl: false, // Optional: Hide Street View person if you want cleaner look
        mapTypeControl: false,    // Optional: Hide Map/Satellite switch if not needed
        fullscreenControl: false, // Optional: Hide Fullscreen button
      });

      // 2. Dispatch map to Redux store
      setMapInstance(map);
    },
    // We intentionally only run this when 'loaded' becomes true or if project ID changes initially.
    // mapRef.current doesn't need to be in deps but helps linting.
    [loaded, project?.id, mapInstance] 
  );

  return (
    <div className="full-width" style={{ position: 'relative' }}>
      {loaded && mapInstance && React.Children.map(children, child => 
        React.cloneElement(child, { mapInstance })
      )}
      <div style={{ height: window.innerHeight * 0.82 }} ref={mapRef}>
        {!loaded && 'Loading Map...'}
      </div>
    </div>
  );
}

const WrappedSchedulingMapWrapper = googleMaps()(SchedulingMapWrapper);
export default WrappedSchedulingMapWrapper;